import {
  StatusTypes,
  StatusActions,
} from '@modules/status/store/status.action';
import { ContractStatusInterface } from '@modules/status/models/contractStatus.interface';
import { ProposalStatusInterface } from '@modules/status/models/proposalStatus.interface';

export class StatusState {
  public proposalStatus: ProposalStatusInterface;
  public contractStatus: ContractStatusInterface;
}

export function reducer(
  state = new StatusState(),
  action: StatusActions
): StatusState {
  switch (action.type) {
    case StatusTypes.SetProposalStatus:
      return {
        ...state,
        proposalStatus: action.payload,
      };
    case StatusTypes.SetContractStatus:
      return {
        ...state,
        contractStatus: action.payload,
      };
    default: {
      return state;
    }
  }
}
